// Copy button
document.addEventListener('click', (e) => {
    const btn = e.target.closest('.mnl-coupon__copy');
    if (!btn) return;
    const val = btn.getAttribute('data-copy') || '';
    if (!val) return;

    navigator.clipboard?.writeText(val).then(() => {
        const prev = btn.textContent;
        btn.textContent = 'Copié ✓';
        setTimeout(() => (btn.textContent = prev), 1200);
    });
});